import * as React from 'react';
import { themr } from 'react-css-themr';
import theme from './ProgressBar.scss';
import ToolboxProgressBar from 'react-toolbox/lib/progress_bar';

class ProgressBar extends React.Component {
    render() {
        return <ToolboxProgressBar {...this.props} />;
    }
}

ProgressBar.defaultProps = {
    buffer: 100
};
const ThemedProgressBar = themr('ProgressBar', theme)(ProgressBar);
export default ThemedProgressBar;
export { ThemedProgressBar as ProgressBar };
